<template>
  <el-config-provider :locale="zhCn">
    <RouterView />
    <ToastHud />
  </el-config-provider>
</template>
<script setup lang="ts">
// @ts-ignore
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import ToastHud from '@/components/hud/ToastHud.vue';

if (navigator?.platform?.toUpperCase()?.indexOf('MAC') >= 0) {
  document.body.classList.add('mac-os');
}
</script>
